import { render, staticRenderFns } from "./SuspectedPatient.vue?vue&type=template&id=6ded128f&"
import script from "./SuspectedPatient.vue?vue&type=script&lang=js&"
export * from "./SuspectedPatient.vue?vue&type=script&lang=js&"
import style0 from "./SuspectedPatient.vue?vue&type=style&index=0&id=6ded128f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports